import { ExportItemSetFormat } from '@exam-management/graphql';
import { z } from 'zod';

import { ItemSetExportFileTemplate } from '../../constants';

export const ItemSetExportFormSchema = z.object({
  fileType: z.nativeEnum(ExportItemSetFormat),
  template: z.nativeEnum(ItemSetExportFileTemplate),
});

export type ItemSetExportFormInput = z.infer<typeof ItemSetExportFormSchema>;
